import { Select } from 'antd';
import { sortBy } from 'lodash';
import React, { Component } from 'react';

export default class SelectModels extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { disabled, models, selected, onChange } = this.props;
    return (
      <Select
        showSearch
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
        defaultValue={selected}
        options={sortBy(models, ['vhc_modl_name']).map((m) => ({
          value: m.vhc_modl_id,
          label: m.vhc_modl_name,
        }))}
        onChange={onChange}
        disabled={disabled}
      />
    );
  }
}
